export default __webpack_public_path__ + "static/media/MP5_3.c6a690d6.png";